export default {
  OPEN_FILTER_TAKEOVER: "OPEN_FILTER_TAKEOVER",
  OPEN_MAP_TAKEOVER: "OPEN_MAP_TAKEOVER",
};



// WEBPACK FOOTER //
// ./assets/shared/constants/mobile.js